import { CapitalEventEditPage } from "features/capital-activity/event/CapitalEventEditPage";
import { CapitalEventReviewPage } from "features/capital-activity/event/CapitalEventReviewPage";
import { useFundFamilyEventRetrieveSuspense } from "gen/endpoints/fund-family-event/fund-family-event";
import { FundFamilyEventStateMachineFieldsEnum } from "gen/model/fundFamilyEventStateMachineFieldsEnum";
import { PermissionTypeEnum } from "gen/model/permissionTypeEnum";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { useHasPermission } from "shared/utils/PermissionUtils";

export const CapitalEventPage: React.FC = () => {
  const { fundFamilyId, fundFamilyEventId } = useRequiredStringParams();
  const { data: capitalActivityData } = useFundFamilyEventRetrieveSuspense(
    fundFamilyId,
    fundFamilyEventId,
  );
  const isWriteActive = useHasPermission(PermissionTypeEnum.write);

  if (
    capitalActivityData.state ===
      FundFamilyEventStateMachineFieldsEnum.completed ||
    capitalActivityData.state ===
      FundFamilyEventStateMachineFieldsEnum.out_of_date ||
    !isWriteActive
  ) {
    return <CapitalEventReviewPage />;
  }

  return <CapitalEventEditPage />;
};
